'use client'

import { FavoriteButtonPrimary } from 'favorite/src/FavoriteButtonPrimary'
import { ProductLocations } from 'product/types/ProductLocations'

import { dataTestIds } from '../../constants/dataTestIds/dataTestIds'
import { useColors } from '../../contexts/ColorsProvider/ColorsProvider'
import { useSizes } from '../../contexts/SizesProvider/SizesProvider'
import type { CommonProps } from '../../types/CommonProps'

import styles from './FavoriteButtonLegacy.module.scss'

const TEST_IDS = {
	large: {
		active: dataTestIds['pdp.productInfo.favorite.active'],
		inactive: dataTestIds['pdp.productInfo.favorite.inactive'],
	},
	small: {
		active: dataTestIds['pdp.productInfo.favorite.active.small'],
		inactive: dataTestIds['pdp.productInfo.favorite.inactive.small'],
	},
}

type FavoriteButtonProps = Pick<CommonProps, 'product'>

export function FavoriteButtonLegacy({
	product,
}: FavoriteButtonProps): React.ReactNode {
	const { selectedColor } = useColors()
	const { isUniqueSize } = useSizes()

	const shouldShowLabelOnLarge = !selectedColor.isSellable
	const shouldShowLabelOnSmall = !selectedColor.isSellable && isUniqueSize

	return (
		<>
			<FavoriteButtonPrimary
				productId={product.id}
				selectedColorId={selectedColor.id}
				dataTestIds={TEST_IDS.large}
				location={ProductLocations.Main}
				className={styles.showLabelFavoriteButton}
				showLabel={shouldShowLabelOnLarge}
				notification
			/>
			<FavoriteButtonPrimary
				productId={product.id}
				selectedColorId={selectedColor.id}
				showLabel={shouldShowLabelOnSmall}
				dataTestIds={TEST_IDS.small}
				location={ProductLocations.Main}
				className={styles.notShowLabelFavoriteButton}
				notification
			/>
		</>
	)
}
